import { NgModule } from 'ng-metadata/core';
import {PrmPersonalizeResultsButton} from './personalizationButton/personalizeResultsButton.directive';
import {PersonalizeResultsButtonService} from './personalizationButton/personalizeResultsButton.service';
import {PrmPersonalizationDialog} from './personalizationDialog/personalizationDialog.directive';
import {PersonalizationDialogService} from './personalizationDialog/personalizationDialog.service';

@NgModule({
    declarations: [PrmPersonalizeResultsButton,PrmPersonalizationDialog],
    providers: [PersonalizeResultsButtonService,PersonalizationDialogService],
    imports:[

    ]
})
export class PersonalizeResultsButtonModule {}


// WEBPACK FOOTER //
// ./src/main/webapp/components/search/personalization/personalizeResultsButton.module.ts